import { createColumnHelper } from '@tanstack/react-table';
import Button from 'components/button';
import TableComponent from 'components/table';
import { HiArrowRight } from 'react-icons/hi';
import { MdCheckCircle, MdCancel, MdOutlineError } from 'react-icons/md';
import { Link } from 'react-router-dom';

type TripHistory = {
  _id: string;
  createdAt: string;
  billing: { totalAmount: string };
  state: string;
  package: { _id: string; packageName: string };
};

const tripHistoryColumnHelper = createColumnHelper<TripHistory>();
const tripColumns = [
  tripHistoryColumnHelper.accessor('package', {
    id: 'packageName',
    header: () => <p className="  ">PACKAGE</p>,
    cell: (info) => <p className="  ">{info.getValue()?.packageName || '-'}</p>,
  }),
  tripHistoryColumnHelper.accessor('billing', {
    id: 'bookingAmount',
    header: () => <p className="  ">AMOUNT (PKR)</p>,
    cell: (info) => <p className="  ">{info.getValue()?.totalAmount || '-'}</p>,
  }),
  tripHistoryColumnHelper.accessor('createdAt', {
    id: 'tripDate',
    header: () => <p className=" ">DATE</p>,
    cell: (info) => <p className="  ">{info.getValue()?.substring(0, 10)}</p>,
  }),
  tripHistoryColumnHelper.accessor('state', {
    id: 'bookingStatus',
    header: () => <p className="  ">STATUS</p>,
    cell: (info) => (
      <div className="flex items-center">
        {info.getValue() === 'successful' ? (
          <MdCheckCircle className="me-1 text-green-500 dark:text-green-300" />
        ) : info.getValue() === 'unsuccessful' ? (
          <MdCancel className="me-1 text-red-500 dark:text-red-300" />
        ) : info.getValue() === 'pending' ? (
          <MdOutlineError className="me-1 text-amber-500 dark:text-amber-300" />
        ) : null}
        <p className="text-md font-medium capitalize">{info.getValue()}</p>
      </div>
    ),
  }),
  tripHistoryColumnHelper.accessor('_id', {
    id: 'bookingId',
    header: () => <p className="  ">DETAILS</p>,
    cell: (info) => (
      <Link target="_blank" to={`/admin/booking/${info.getValue()}`}>
        <Button type="icon">
          <HiArrowRight />
        </Button>
      </Link>
    ),
  }),
];
const TripHistory = ({ tripHistory }: any) => {
  const fetchData = (options: { pageIndex: number; pageSize: number }) => {
    const { pageIndex, pageSize } = options;
    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;

    const paginatedData = tripHistory.slice(startIndex, endIndex);
    const pageCount = Math.ceil(tripHistory.length / pageSize);
    return { rows: paginatedData, pageCount };
  };
  return (
    <TableComponent
      header="Trip History"
      fetchData={fetchData}
      columns={tripColumns}
    />
  );
};

export default TripHistory;
